<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab title="Summary" active>
                <b-card-body>
                    <b-row>
                        <b-col cols="9">
                            <b-alert
                                variant="warning"
                                show
                                class="
                                    my-2
                                    font-weight-bold
                                    py-1
                                    w-200
                                    my-0
                                    text-center
                                "
                            >
                                {{ orderTypeName.toUpperCase() }}
                            </b-alert>
                            <h3 class="font-weight-bolder">
                                <!-- {{ order.description }}</-->
                                Reference Number
                                <span class="text-muted"
                                    >#{{ order.reference_no }}
                                </span>
                            </h3>

                            <div class="mt-2">
                                <h4 class="font-weight-bold">
                                    Service Details
                                </h4>
                            </div>
                            <b-row>
                                <b-col variant="dark">
                                    <h6 class="font-weight-bolder">
                                        Created At:
                                    </h6>
                                    <h6>
                                        {{ order.created_at | filterDate }}
                                    </h6>
                                </b-col>

                                <b-col variant="dark">
                                    <h6 class="font-weight-bolder">
                                        Engineer Assigned:
                                    </h6>
                                    <h5>
                                        {{ order.driver | filterOfficerName }}
                                    </h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <h6 class="font-weight-bolder">
                                        Due Date:
                                    </h6>
                                    <h6>
                                        {{ order.schedule_at | filterDate }}
                                    </h6>
                                </b-col>
                                <b-col>
                                    <h6 class="font-weight-bolder">
                                        Service Price:
                                    </h6>
                                    <h6>
                                        {{ order.items | filterPrice }}
                                    </h6>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <h6 class="font-weight-bolder">
                                        Due Time:
                                    </h6>
                                    <h6>
                                        {{ order.schedule_at | filterTime }}
                                    </h6>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <h6 class="font-weight-bolder">
                                        Order Category:
                                    </h6>
                                    <h6>
                                        {{
                                            order.category &&
                                            order.category.name
                                        }}
                                    </h6>
                                </b-col>
                            </b-row>

                            <b-row style="mb-2">
                                <b-col>
                                    <h6 class="font-weight-bolder">
                                        Description:
                                    </h6>
                                    <h6>
                                        {{ order.description }}
                                    </h6>
                                </b-col>
                            </b-row>
                            <br />
                            <b-row style="mb-4">
                                <b-col class="mt-2">
                                    <h4 class="font-weight-bold">
                                        Service Location
                                    </h4>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <h6 class="font-weight-bold">
                                        Address Line 1:
                                    </h6>
                                    <h6>
                                        {{
                                            (order.delivery_location_section &&
                                                order.delivery_location_section
                                                    .location.address1) ||
                                            '-'
                                        }}
                                    </h6>
                                </b-col>
                                <b-col>
                                    <h6 class="font-weight-bold">
                                        Address Line 2:
                                    </h6>
                                    <h6>
                                        {{
                                            (order.delivery_location_section &&
                                                order.delivery_location_section
                                                    .location.address2) ||
                                            '-'
                                        }}
                                    </h6>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <h6 class="font-weight-bold">City:</h6>
                                    <h6>
                                        {{
                                            (order.delivery_location_section &&
                                                order.delivery_location_section
                                                    .location.city) ||
                                            '-'
                                        }}
                                    </h6>
                                </b-col>
                                <b-col>
                                    <h6 class="font-weight-bold">
                                        Country Code:
                                    </h6>
                                    <h6>
                                        {{
                                            (order.delivery_location_section &&
                                                order.delivery_location_section
                                                    .location.country_code) ||
                                            '-'
                                        }}
                                    </h6>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-tab>
            <b-tab title="Messages">
                <b-card-body><ServiceNotes :order="order" /></b-card-body>
            </b-tab>
            <b-tab title="Attachments">
                <b-card-body>
                    <ServiceAttachments :order="order" />
                </b-card-body>
            </b-tab>
            <b-tab title="Documents">
                <b-container fluid class="p-4 bg-light">
                    <b-button class="my-2" @click="downloadPdf">
                        Download Documents
                        <b-spinner
                            class="ml-2"
                            small
                            v-if="loading"
                        ></b-spinner>
                        <b-icon
                            v-else
                            class="ml-2"
                            icon="cloud-download"
                            aria-hidden="true"
                        ></b-icon>
                    </b-button>
                </b-container>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

import ServiceAttachments from './ServiceAttachments'
import ServiceNotes from './ServiceNotes'

export default {
    name: 'CustomerPortalViewService',
    components: {
        ServiceAttachments,
        ServiceNotes,
    },
    mixins: [popupMixins],
    data() {
        return {
            loading: false,
        }
    },
    filters: {
        filterDate(date) {
            if (!date) return ''
            return date.split(' ')[0]
        },
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
        filterTime(date) {
            if (!date) return ''
            return date.split(' ')[1]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = (items || []).reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'
            return formatter.format(sum)
        },
    },
    computed: {
        orderTypeName() {
            return (
                (this.order &&
                    this.order.type &&
                    (this.order.type.customer_portal_name ||
                        this.order.type.name)) ||
                ''
            )
        },
        order() {
            console.log('Order is: ')
            const computedOrder =
                this.$store.state.customerPortal.selectedOrder || {}
            console.log(computedOrder)
            return computedOrder
        },
    },
    watch: {},
    mounted() {
        this.$store.dispatch('customerPortal/fetchOrder', this.$route.params.id)
    },
    methods: {
        async downloadPdf() {
            try {
                this.loading = true
                const rpt_type = 'statement'
                const queryString = `&id=${this.order.id}`
                const fileName = 'statement.pdf'
                console.log('report params:', {
                    rpt_type,
                    queryString,
                    fileName,
                })
                await this.$store.dispatch('js_report/downloadDocument', {
                    rpt_type,
                    queryString,
                    fileName,
                })
            } catch (error) {
                console.error('downloadPdf:', error)
                this.doToast('Error!', 'Error Downloading Report!', 'danger')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
<style></style>
